import ToolTipComponent from "../ToolTipComponent";
import useMobile from "../../../hooks/useMobile";
import { useSelection } from "../../../contexts/SelectionContext";

export default function Input({
  name,
  id,
  required,
  titleRus,
  message,
  restrictions,
  value,
  onChange,
  onBlur,
  onBlock,
  ...props
}) {
  const { inputErrors, floatingRules } = useSelection();

  const isMobile = useMobile();

  let fieldError;
  if (inputErrors) {
    if (inputErrors.emptyRule?.length > 0)
      fieldError = inputErrors.emptyRule.find((item) => item.inputId === id);
    if (inputErrors.valueRule && !fieldError)
      fieldError = inputErrors.valueRule;
  }

  const floatedValue =
    floatingRules && id in floatingRules && floatingRules[id] > 0;

  // Разрешаем ввод минуса, если поле допускает отрицательные значения
  const allowNegative =
    restrictions && Number(restrictions.min) < 0;

  const checkRestrictions = (value) => {
    if (value === "") {
      onChange(null);
      return;
    }

    const numValue = Number(value);

    if (isNaN(numValue)) {
      // Незавершенный ввод минуса не сбрасываем
      onChange(allowNegative && value === "-" ? "-" : null);
      return;
    }

    let correctedValue = numValue;
    if (numValue < restrictions.min) correctedValue = restrictions.min;
    if (numValue > restrictions.max) correctedValue = restrictions.max;
    onChange(Number(correctedValue));
    return;
  };

  const handleChange = (e) => {
    if (onBlock) return;

    let newValue = e.target.value;

    let filteredValue = newValue.replace(/,/g, ".");

    if (allowNegative) {
      // Оставляем цифры, точку и один ведущий минус
      filteredValue = filteredValue
        .replace(/[^0-9.-]/g, "")
        .replace(/^(-)?(\d*\.?\d*)-/g, "$1$2")
        .replace(/^0+(?=\d)/, "")
        .replace(/^(\d*\.\d*)\./g, "$1");
    } else {
      filteredValue = filteredValue
        .replace(/[^0-9.]/g, "")
        .replace(/^0+(?=\d)/, "")
        .replace(/^(\d*\.\d*)\./g, "$1");
    }

    if (newValue !== filteredValue) {
      e.target.value = filteredValue;
    }

    if (!floatedValue) {
      // Только если в поле не может быть дробных чисел
      if (restrictions) checkRestrictions(newValue);
    } else onChange(newValue === "" ? null : filteredValue);
  };

  const handleOnBlur = (e) => {
    if (onBlock) return;

    let newValue = e.target.value;

    onBlur(name, newValue);

    // Только если в поле могут быть дробные числа
    if (floatedValue && restrictions) checkRestrictions(newValue);
  };

  return (
    <div
      id={id}
      className={`form-group ${isMobile ? "form-group-vertical" : ""}`}
    >
      <div className="label-group">
        <label
          htmlFor={id}
          className={`text-s ${required ? `required_${required}` : ""}`}
        >
          {titleRus}
        </label>
      </div>

      <div className="input-item">
        <input
          type="text"
          autoComplete="off"
          id={id}
          name={name}
          value={value !== null && value !== undefined ? value : ""}
          required={required === "required" ? true : false}
          onChange={handleChange}
          onBlur={(e) => handleOnBlur(e)}
          {...props}
          className={`text-m
            ${fieldError?.inputId === id ? "input-error" : ""} 
            ${onBlock ? "input-blocked" : ""}
          `}
        />
      </div>
    </div>
  );
}
